module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT1000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT1000.png
// module id = 1403
// module chunks = 1